import SetNewStore from "./SetNewStore";

export default SetNewStore;
